module.exports = __webpack_public_path__ + "static/media/FE2100-51E_03.200a2d78.png";